import { render } from "./vh-clock.vue?vue&type=template&id=cb1ac95a"
import script from "./vh-clock.vue?vue&type=script&lang=js"
export * from "./vh-clock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__